import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AgencyZonesQueryVariables = Types.Exact<{
  agencyId: Types.Scalars['ID'];
}>;


export type AgencyZonesQuery = { __typename?: 'Query', AgencyZones: Array<{ __typename?: 'ZoneGeometryDto', zoneCode: string, polygonsGeoJson: string }> };


export const AgencyZonesDocument = gql`
    query AgencyZones($agencyId: ID!) {
  AgencyZones(agencyId: $agencyId) {
    zoneCode
    polygonsGeoJson
  }
}
    `;

/**
 * __useAgencyZonesQuery__
 *
 * To run a query within a React component, call `useAgencyZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyZonesQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useAgencyZonesQuery(baseOptions: Apollo.QueryHookOptions<AgencyZonesQuery, AgencyZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyZonesQuery, AgencyZonesQueryVariables>(AgencyZonesDocument, options);
      }
export function useAgencyZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyZonesQuery, AgencyZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyZonesQuery, AgencyZonesQueryVariables>(AgencyZonesDocument, options);
        }
export type AgencyZonesQueryHookResult = ReturnType<typeof useAgencyZonesQuery>;
export type AgencyZonesLazyQueryHookResult = ReturnType<typeof useAgencyZonesLazyQuery>;
export type AgencyZonesQueryResult = Apollo.QueryResult<AgencyZonesQuery, AgencyZonesQueryVariables>;